<div class="pm-login-page">
  <header></header>
  <div class="pm-login-container">
    <div class="logo-container">
      <app-processmanager-logo [logo]="logoUrl$ | async"></app-processmanager-logo>
    </div>

    @if (state === 'domain') {
      <pm-domain-form (domain)="onDomainChosen($event)" (reset)="onReset()" [error]="translatedError$ | async" ></pm-domain-form>
    }
    @if (state === 'login') {
      <pm-login-form [domain]="domain$ | async" [error]="translatedError$ | async" [pending]="pending$ | async"
      [returnUrl]="returnUrl$ | async" (authenticated)="onAuthenticated($event)" (reset)="onReset()" (backToDomain)="onBackToDomains()"></pm-login-form>
    }
    @if (state === 'reset') {
      <pm-login-reset-form [domain]="domain$ | async" [error]="translatedError$ | async"
        [pending]="pending$ | async" (resetRequest)="onResetRequest($event)"
      (cancelRequest)="onResetCancel()"></pm-login-reset-form>
    }
  </div>
  <footer></footer>
</div>
